module.exports = __webpack_public_path__ + "10_hair_black.e4db6fa8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/10_hair_black.png
// module id = DfdJ
// module chunks = 0